export enum RoutePath {
  Login = 'login',
  TelegramAccountList = 'telegram-account',
  TelegramAccountChatHistory = 'telegram-account-chat-history',
  AccountCreation = 'telegram-account/account-creation',
  AccountManagement = 'telegram-account/account-management',
  AccountAssignment = 'telegram-account/account-assignment',
  NotFound = '404',
  NoAccess = '403',
  MassMessaging = 'telegram-account/mass-messaging',
}
